// The service accepts any whole number from 0 up (an int32); several institutions may share one.
export const parseDisplayOrder = (raw: string): number | null => {
  const trimmed = raw.trim()
  if (!/^\d+$/.test(trimmed)) return null
  const value = Number(trimmed)
  return value <= 2147483647 ? value : null
}
